export const CONFIG_MAP = {
	adminpanel: "adminpanel",
	weatherdata: "weatherdata",
} as const;
